var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{attrs:{"image":"error","description":"认证失败，无法访问系统资源"}})}
var staticRenderFns = []

export { render, staticRenderFns }